<template>
  <div class="home-banner-slider-container">
    <div class="slider-outer">
      <div class="slider-indicators-container">
        <div class="slider-indicator-wrapper">
          <div class="slider-indicators">
            <div
              v-for="(number, index) in sliderLength"
              :key="number"
              class="slider-indicator"
              :data-slider-index="index"
              @click="updateSlider(index)">
              <div class="indicator-obj"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="home-banner-slider-inner" class="slider-inner">
      <div class="slider-items">
        <div
          v-for="(item, index) in sliderItemList"
          :key="index"
          class="slider-item"
          :data-slider-index="index">
          <div class="slider-media">
            <img :src="item">
          </div>
          <div
            class="slider-content-container"
            :class="{
            'is-mobile': isMobile,
            'slider-camera': index === 0,
            'slider-breathing': index === 1,
            'slider-snapcute': index === 2,
            'slider-aidiary': index === 3,
            'slider-delivery': index === 4,
            'position-higher': ['es', 'fr', 'it'].includes(languageCode)}">
            <!-- <div class="img-icon">
              <img
                v-if="index === 1 && !isMobile"
                class="tag-img-new-feature"
                src="/media/img/icons/care/icon_new_feature.svg"
                alt="icon_img_tag_new_feature">
            </div> -->
            <div class="text-title-home-slide" :class="{ 'is-mobile': isMobile }">
              <div
                v-if="index === 0"
                class="home-slider-title">
                {{ $t('home.slider_camera.title') }}
              </div>
              <div
                v-if="index === 1"
                class="home-slider-title"
                :class="{
                  'no-wrap': languageCode === 'en' && !isMobile,
                  'narrow-width': languageCode === 'en' && isMobile}">
                <!-- <span v-if="isMobile" class="tag-new">NEW</span> -->
                {{ $t('home.slider_breathing.title') }}
                <!-- <span class="with-beta">
                  ({{ $t('care.sectionBreathing.featureNameBeta') }})
                </span> -->
              </div>
              <div
                v-if="index === 2"
                class="home-slider-title">
                {{ $t('home.slider_snapcute.title') }}
              </div>
              <div
                v-if="index === 3"
                class="home-slider-title">
                {{ $t('home.slider_aidiary.title') }}
              </div>
              <div
                v-if="index === 4"
                class="home-slider-title">
                {{ $t('home.slider_delivery.title2') }}
              </div>
            </div>
            <div class="text-content-desc text-content-desc-slide">
              <span v-if="index === 0">{{ $t('home.slider_camera.desc') }}</span>
              <span v-if="index === 1">{{ $t('home.slider_breathing.desc') }}</span>
              <span v-if="index === 2">{{ $t('home.slider_snapcute.desc') }}</span>
              <span v-if="index === 3">{{ $t('home.slider_aidiary.desc') }}</span>
              <span v-if="index === 4">{{ $t('home.slider_delivery.desc2') }}</span>
            </div>
            <div
              v-if="index === 1"
              class="additional-container">
              <ul class="icon-list">
                <li class="icon-container">
                  <img
                    class="icon-img icon-img--no-extra-device"
                    src="/media/img/icons/home/icon-no-extra-device.svg"
                    alt="icon_non_contact">
                  <div
                    class="text text--no-extra-device"
                    :class="{'text--long': ['es', 'it', 'de'].includes(languageCode)}">
                    {{ $t('home.slider_breathing.icon_no_extra_device') }}
                  </div>
                </li>
                <li><div class="line"></div></li>
                <li class="icon-container">
                  <img
                    class="icon-img"
                    src="/media/img/icons/home/icon-ai.svg"
                    alt="icon_ai_detection">
                  <div class="text">{{ $t('home.slider_breathing.icon_ai') }}</div>
                </li>
                <li><div class="line"></div></li>
                <li class="icon-container">
                  <img
                    class="icon-img"
                    src="/media/img/icons/home/icon-accuracy.svg"
                    alt="icon_99.99%_accuracy">
                  <div class="text">{{ $t('home.slider_breathing.icon_accuracy') }}</div>
                </li>
                <li><div class="line"></div></li>
                <li class="icon-container">
                  <img
                    class="icon-img icon-img--leading"
                    src="/media/img/icons/home/icon-leading.svg"
                    alt="icon_industry_leading">
                  <div class="text leading">
                    {{ $t('home.slider_breathing.icon_leading') }}
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-if="index === 3"
              class="additional-container">
              <ul class="icon-list">
                <li class="icon-container">
                  <img
                    class="icon-img"
                    src="/media/img/icons/home/icon_ai_gen.svg"
                    alt="icon_ai_generation">
                  <div class="text aigen">{{ $t('home.slider_aidiary.icon_ai_gen') }}</div>
                </li>
                <li><div class="line"></div></li>
                <li class="icon-container">
                  <img
                    class="icon-img"
                    src="/media/img/icons/home/icon_max_saved.svg"
                    alt="icon_max_saved">
                  <div class="text aigen">{{ $t('home.slider_aidiary.icon_max_saved') }}</div>
                </li>
              </ul>
            </div>
            <a
              class="btn btn-slider-more"
              :href="sliderItemContentLink(index)"
              target="_self">
              <span v-if="[0].includes(index)">{{ $t('common.learnMore') }}</span>
              <span v-if="[1].includes(index)">{{ $t('home.slider_btn.try') }}</span>
              <span v-if="[2].includes(index)">{{ $t('home.slider_btn.try') }}</span>
              <span v-if="[3].includes(index)">{{ $t('common.learnMore') }}</span>
              <span v-if="[4].includes(index)">{{ $t('home.slider_btn.shop') }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="slider-controllers">
        <div class="slider-controller slider-controller-left" @click="prev">
          <div class="icon-wrapper">
            <q-icon name="o_chevron_left" />
          </div>
        </div>
        <div class="slider-controller slider-controller-right" @click="next">
          <div class="icon-wrapper">
            <q-icon name="o_chevron_right" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'home-banner-slider',
  data() {
    return {
      sliderIndex: 0,
      // 輪播時間間隔： 5000ms (5s)
      autoPlayTimerHome: 5000,
      // indicator 距離
      indicatorDistance: 100,
      // indicator 初始位置
      indicatorsPosition: 0,
      // Desktop 圖片來源
      desktopSliderItemList: [
        '/media/img/home/slider_camera.jpg',
        '/media/img/home/slider_breathing.jpg',
        '/media/img/home/slider_snapcute.jpg',
        '/media/img/home/slider_aidiary.jpg',
        '/media/img/home/slider_delivery.jpg',
      ],
      // Mobile 圖片來源
      mobileSldierItemList: [
        '/media/img/home/m_slider_camera.jpg',
        '/media/img/home/m_slider_breathing_v2.jpg',
        '/media/img/home/m_slider_snapcute.jpg',
        '/media/img/home/m_slider_aidiary.jpg',
        '/media/img/home/m_slider_delivery.jpg',
      ],
      swipeData: {
        touchStart: 0,
        touchEnd: 0,
        distance: 0,
      },
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
      languageCode: (state) => state.languageCode,
    }),
    sliderItemList() {
      const { isMobile, mobileSldierItemList, desktopSliderItemList } = this;

      return isMobile ? mobileSldierItemList : desktopSliderItemList;
    },
    sliderLength() {
      return this.sliderItemList.length;
    },
  },
  watch: {
    sliderIndex: {
      handler(value, oldValue) {
        const oldActiveElement = document.querySelectorAll(`[data-slider-index="${oldValue}"]`);
        oldActiveElement.forEach((el) => el.classList.remove('active'));

        const newActiveElement = document.querySelectorAll(`[data-slider-index="${value}"]`);
        newActiveElement.forEach((el) => el.classList.add('active'));
      },
      immediate: true,
    },
    'swipeData.distance': {
      handler(value) {
        if (Math.abs(value) < 30) {
          return;
        }

        if (value > 0) {
          this.prev();
          return;
        }

        this.next();
      },
      immediate: true,
    },
  },
  mounted() {
    this.initSlider();
    this.$nextTick(() => this.detectSwipe());
  },
  methods: {
    initSlider() {
      this.initActiveSlider();
      this.attachAutoPlay();
    },
    initActiveSlider() {
      const activeElement = document.querySelectorAll(`[data-slider-index="${this.sliderIndex}"]`);
      activeElement.forEach((el) => el.classList.add('active'));
    },
    attachAutoPlay() {
      const { autoPlayTimerHome, sliderLength } = this;
      setInterval(() => {
        this.sliderIndex = (this.sliderIndex + 1) % sliderLength;
      }, autoPlayTimerHome);
    },
    detectSwipe() {
      const element = document.getElementById('home-banner-slider-inner');
      const self = this;

      element.addEventListener('touchstart', (e) => {
        self.swipeData.touchStart = e.touches[0].clientX;
      }, false);

      element.addEventListener('touchend', (e) => {
        self.swipeData.touchEnd = e.changedTouches[0].clientX;
        self.calculateSwipeDistance();
      }, false);
    },
    calculateSwipeDistance() {
      this.swipeData.distance = this.swipeData.touchEnd - this.swipeData.touchStart;
    },
    prev() {
      this.sliderIndex = this.sliderIndex === 0 ? this.sliderLength - 1 : this.sliderIndex - 1;
    },
    next() {
      this.sliderIndex = this.sliderIndex === (this.sliderLength - 1) ? 0 : this.sliderIndex + 1;
    },
    updateSlider(index) {
      this.sliderIndex = index;
    },
    sliderItemContentLink(index) {
      return {
        0: '/product/camera',
        1: '/product/care',
        2: '/product/care',
        3: 'https://support.lollipop.camera/hc/en-us/articles/23651166589977-What-is-Lollipop-Smart-AI-Diary-',
        4: this.languageCode !== 'zh-Hant'
          ? 'https://shop.lollipop.camera/?utm_source=official_website&utm_medium=page_home&utm_content=banner_slider'
          : 'https://shopee.tw/lollipopbabycarestoretw?shopCollection=247173941#product_list',
      }[index];
    },
  },
};
</script>
<style lang="sass" scoped>
.home-banner-slider-container
  --text-title-home-slide: 54px
  --btn-text: 16px
  --controller-icon-font-size: 24px
  --controller-wrapper-width: 40px
  --indicator-width: 12px
  --font-size-beta: 20px
  position: relative
  width: 100%
  height: 100%
  .slider-outer
    display: block
    width: 100%
    position: absolute
    bottom: 5vh
    left: 50%
    transform: translate(-50%, 100%)
    .slider-indicators-container
      display: flex
      justify-content: center
      width: 100%
      height: 24px
      padding: 0 8px
      .slider-indicator-wrapper
        overflow: hidden
        .slider-indicators
          display: flex
          transform: translate(0, 0)
          transition: all 1s ease
          .slider-indicator
            margin: 0 var(--indicator-width)
            cursor: pointer
            .indicator-obj
              width: var(--indicator-width)
              height: var(--indicator-width)
              border-radius: 50%
              background-color: #C8E7F9
            &.active
              .indicator-obj
                background-color: #6AC6FB
            &:first-child
              margin-left: 4px
            &:last-child
              margin-right: 4px
  .slider-inner
    display: block
    width: 100%
    height: 100%
    .slider-items
      display: flex
      justify-content: center
      align-items: center
      width: 100%
      height: 100%
      .slider-item
        display: none
        .slider-media
          width: 100%
          height: 100%
          img
            width: 100%
            height: 100%
            object-fit: cover
        .slider-content-container
          position: absolute
          text-align: left
          &.slider-camera
            width: 42vw
            top: 50%
            left: 50%
            transform: translate(0, -50%)
          &.slider-delivery
            width: 40vw
            top: 50%
            left: 10%
            transform: translate(0, -50%)
            .text-title-home-slide
              color: $main-text-content-color-light
            .text-content-desc-slide
              color: $main-text-content-color-light
            .btn-slider-more
              background-color: $background-primary
              color: $lollipop-blue
          &.slider-snapcute, &.slider-breathing, &.slider-aidiary
            width: 40vw
            top: 50%
            left: 10%
            transform: translate(0, -50%)
            &.is-mobile
              display: flex
              flex-direction: column
              justify-content: center
              align-items: center
            .img-icon
              margin: 0 0 -24px -4px
              img
                width: 232px
            .text-title-home-slide
              color: $main-text-content-color-light
              &.is-mobile
                display: flex
                justify-content: center
                align-items: center
              .home-slider-title
                position: relative
                &.no-wrap
                  white-space: nowrap
                .tag-new
                  position: absolute
                  top: 0
                  transform: translate(-120%, 50%)
                  color: $main-text-content-color-light
                  font-size: calc( var(--text-title-home-slide) * 0.3 )
                  font-weight: 900
                  padding: 4px calc( var(--text-title-home-slide) * 0.2 )
                  background-color: #ff6666
                  border-radius: calc( var(--text-title-home-slide) * 0.3 )
                  margin-right: calc( var(--text-title-home-slide) * 0.3 )
                .with-beta
                  font-size: var(--font-size-beta)
                  font-weight: 500
                  color: #808080
            .text-content-desc-slide
              color: $main-text-content-color-light
              max-width: 600px
            .btn-slider-more
              color: #F0C8C4
              background-color: $background-primary
          &.slider-breathing
            top: 45%
            .text-title-home-slide
              color: $lollipop-blue
            .text-content-desc-slide
              color: #808080
            .btn-slider-more
              color: $background-primary
              background-color: $lollipop-blue
          &.slider-aidiary
            top: 45%
            .text-title-home-slide
              color: $lollipop-blue
            .text-content-desc-slide
              color: #808080
            .btn-slider-more
              color: $background-primary
              background-color: $lollipop-blue
          &.slider-breathing.position-higher:not(.is-mobile)
            top: 40%
          .text-title-home-slide
            font-size: var(--text-title-home-slide)
            font-weight: 700
            line-height: 1.2
            color: $lollipop-blue
            margin: 16px 0
          .text-content-desc-slide
            color: #808080
          .btn-slider-more
            font-size: var(--btn-text)
            font-weight: 700
            border-radius: 32px
            margin: 24px 0
          .additional-container
            --container-width: 80px
            --icon-text-size: 12px
            --icon-text-long: 100%
            --icon-img-height: 28px
            --icon-img-mb: 12px
            --line-height: 1.25
            margin: 28px 0 0 -8px
            .icon-list
              display: flex
              justify-content: flex-start
              align-items: flex-start
              .icon-container
                width: var(--container-width)
                display: flex
                flex-direction: column
                justify-content: center
                text-align: center
                margin: 0 var(--icon-text-size)
                &:first-child
                  margin-left: 0
                .icon-img
                  height: var(--icon-img-height)
                  margin-bottom: var(--icon-img-mb)
                  &--leading
                    height: calc( var(--icon-img-height) * 1.05 )
                  &--no-extra-device
                    height: calc( var(--icon-img-height) * 1.18 )
                    margin-top: -5px
                .text
                  font-size: var(--icon-text-size)
                  font-weight: 400
                  width: 80%
                  &.leading
                    word-break: break-word
                  &--no-extra-device
                    margin-left: 8px
                  &.aigen
                    word-break: break-word
                  &--long
                    width: var(--icon-text-long)
            .line
              width: 1px
              height: var(--line-height)
              background-color: $lollipop-blue
        &.active
          display: flex
          width: 100%
          height: 100%
    .slider-controllers
      position: absolute
      top: 50%
      left: 0
      transform: translate(0, 0%)
      width: 100%
      height: var(--controller-wrapper-width)
      .slider-controller
        position: absolute
        &.slider-controller-left
          left: 4vw
        &.slider-controller-right
          right: 4vw
        .icon-wrapper
          position: relative
          width: var(--controller-wrapper-width)
          height: var(--controller-wrapper-width)
          background-color: #FAF9F8
          border-radius: 50%
          cursor: pointer
          i
            font-size: var(--controller-icon-font-size)
            color: $main-text-content-color-dark
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)

@media screen and (min-width: 1600px)
  .home-banner-slider-container
    --text-title-home-slide: 72px
    --btn-text: 18px
    --controller-icon-font-size: 32px
    --controller-wrapper-width: 48px
    --indicator-width: 18px
    --font-size-beta: 24px
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            .additional-container
              --container-width: 88px
              --icon-text-size: 14px
              --icon-text-long: 110%
              --icon-img-height: 32px
              margin: 32px 0 4px -8px

@media screen and (max-width: 1024px)
  .home-banner-slider-container
    --text-title-home-slide: 40px
    --btn-text: 12px
    --controller-icon-font-size: 24px
    --controller-wrapper-width: 40px
    --indicator-width: 12px
    .slider-inner
      .slider-items
        .slider-item

@media screen and (orientation: portrait)
  .home-banner-slider-container
    --text-title-home-slide: 48px
    --btn-text: 18px
    --controller-icon-font-size: 24px
    --controller-wrapper-width: 36px
    --indicator-width: 12px
    --font-size-beta: 13px
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            position: absolute
            text-align: center
            &.slider-camera, &.slider-snapcute, &.slider-delivery,
            &.slider-breathing, &.slider-aidiary
              width: 80vw
              top: 20%
              left: 50%
              transform: translate(-50%, -50%)
            &.slider-breathing
              .text-title-home-slide
                white-space: break-space
            .additional-container
              display: none

@media screen and (max-width: 576px)
  .home-banner-slider-container
    --text-title-home-slide: 36px
    --btn-text: 14px
    --controller-icon-font-size: 20px
    --controller-wrapper-width: 32px
    --indicator-width: 8px
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            &.slider-camera, &.slider-snapcute, &.slider-delivery,
            &.slider-breathing, &.slider-aidiary
              width: 95vw
              top: 20%
              left: 50%
              transform: translate(-50%, -50%)
            .btn-slider-more
              padding: 8 16px
              margin: 12px 0

@media screen and (max-width: 414px)
  .home-banner-slider-container
    --text-title-home-slide: 32px
    --controller-icon-font-size: 16px
    --controller-wrapper-width: 28px
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            &.slider-camera, &.slider-snapcute, &.slider-delivery,
            &.slider-breathing, &.slider-aidiary
              top: 25%

@media screen and (max-width: 414px) and (max-aspect-ratio: 1/2)
  .home-banner-slider-container
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            &.slider-camera, &.slider-snapcute, &.slider-delivery,
            &.slider-breathing, &.slider-aidiary
              top: 18%

@media screen and (max-width: 360px)
  .home-banner-slider-container
    --text-title-home-slide: 32px
    --controller-icon-font-size: 14px
    --controller-wrapper-width: 24px
    --btn-text: 14px

@media screen and (max-width: 320px)
  .home-banner-slider-container
    --btn-text: 12px

/** iPad Pro */
@media screen and (min-width: 960px) and (min-aspect-ratio: 3/5) and (max-aspect-ratio: 9/10)
  .home-banner-slider-container
    --text-title-home-slide: 72px
    --btn-text: 28px
    --controller-icon-font-size: 32px
    --controller-wrapper-width: 48px
    --indicator-width: 18px
    .slider-inner
      .slider-items
        .slider-item
          .slider-content-container
            position: absolute
            text-align: center
            &.slider-camera, &.slider-snapcute, &.slider-delivery,
            &.slider-breathing, &.slider-aidiary
              width: 80vw
              top: 18%
              left: 50%
              transform: translate(-50%, -50%)
</style>
